// src/core/NineUxUtil.js
import { nineAlertPopup, nineConfirmPopup } from './nineConfirm.js';
import { ninePromptPopup } from "./ninePrompt.js";
import { nine } from '../../core/Config.js'; // 🚀 1. Config에서 nine 객체 임포트

export class NineUxUtil {
	// static 필드는 클래스 자체에 저장됨
	static cssPath = "";

	/**
	 * 팝업 준비 로직 (Private 메서드)
	 */
	#prepare(type, message, title, defaultClass) {

		const options = { class: defaultClass, animation: 'fade' };
		//const popup = type === 'alert' ? nineAlertPopup : (type === 'confirm' ? nineConfirmPopup : ninePromptPopup);
		let isExecuted = false;

		const popupMap = {
			alert: nineAlertPopup,
			confirm: nineConfirmPopup,
			prompt: ninePromptPopup
		};

		const popup = popupMap[type];

		const runner = {
			rgb:     () => { options.class = 'rgb'; return runner; },
			classic: () => { options.class = 'classic'; return runner; },
			shake:   () => { options.animation = 'shake'; return runner; },
			run:     () => { options.animation = 'roadRunner'; return runner; },
			zoom:    () => { options.animation = 'zoom'; return runner; },

			then: (resolve, reject) => {
				isExecuted = true;
				return popup[type](message, title, options).then(resolve, reject);
			}
		};

		// Microtask: 동기 체이닝이 모두 끝난 후 실행
		Promise.resolve().then(() => {
			if (!isExecuted) {
				isExecuted = true;
				popup[type](message, title, options);
			}
		});

		return runner;
	}

	alert = (message, title = "Alert") => {
		return this.#prepare('alert', message, title, 'classic');
	}

	confirm = (message, title = "Confirm") => {
		return this.#prepare('confirm', message, title, 'classic');
	}

	prompt = (message, title = "Prompt") => {
		return this.#prepare('prompt', message, title, 'classic');
	}
}

Object.assign(nine, new NineUxUtil());